import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL } from 'app/helpers/globals';
import { map, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {

  constructor(
    private readonly http: HttpClient
  ) { }

  getInformationForTheAuthorities(clientId: number, periodStart:Date, periodEnd:Date, vins: string[]){
    // add one day to the end date
    const endDate = new Date(periodEnd);
    endDate.setDate(endDate.getDate() + 1);
    const startDate = new Date(periodStart);
    startDate.setDate(startDate.getDate() + 1);
    const body = {
      clientId,
      periodStart:Math.floor(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate(), 0,0,0,0)/1000),
      periodEnd:Math.floor(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate(), 23,59,59,999)/1000),
      vins
    }
    return this.http.post<GetInformationForTheAuthoritiesResponse>(`${API_URL}getInformationsForTheAuthorities`, body, {withCredentials: true})
    .pipe(share()).pipe(map((response) => response));
  }

  downloadFilesPerEntities(vins: string[], cardNumbers: string[], clientId: number, periodStart: number, periodEnd: number, tcFormat: string, dcFormat: string){
    const body = {
      vins,
      cardNumbers,
      clientId,
      periodStart,
      periodEnd,
      tcFormat,
      dcFormat
    }
    return this.http.post(`${API_URL}downloadFilesPerEntities`, body, {
      withCredentials: true,
      responseType: 'arraybuffer',
      observe: 'response'
    }).pipe(map((response) => response.body));
  }

}


export type GetInformationForTheAuthoritiesResponse = {
  result: 'success' | string;
  selectedPeriodStartHR: string;
  selectedPeriodStart: number;
  selectedPeriodEndHR: string;
  selectedPeriodEnd: number;
  coverageAnalysis: {
    selectedVehicle: string;
    selectedVehicleRegNr: string;
    coverageMap: Record<string, {
      type: 'vehicle' | 'driver';
      covered: string[];
      missing: string[];
    }>;
    notUploadedDriverCards: string[];
    downloadInformations: {
      identificationNumber: string;
      identificationName: string;
      fileOriginalName: string;
      uploadTime: number;
      uploadTimeHR: string;
      fileType: string;
      firstActivityTime: number;
      firstActivityTimeHR: string;
      lastActivityTime: number;
      lastActivityTimeHR: string;
      userName: string;
    }[]
  }[]
}